export default __webpack_public_path__ + "static/media/agustin19.84c0cb5d.png";